var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-checkbox", {
    attrs: {
      id: _vm.id,
      "data-test-id": "onChange",
      disabled: !_vm.isVisible(null, false),
      "input-value": _vm.value,
      color: _vm.color,
      dark: _vm.dark,
      light: _vm.light,
      loading: _vm.loading,
      "append-icon": _vm.appendIcon,
      "append-icon-cb": _vm.appendIconCb,
      "background-color": _vm.backgroundColor,
      error: _vm.error,
      "error-count": _vm.errorCount,
      "error-messages": _vm.errorMessages,
      "false-value": _vm.falseValue,
      height: _vm.height,
      "hide-details": _vm.hideDetails,
      hint: _vm.hint,
      indeterminate: _vm.indeterminate,
      "indeterminate-icon": _vm.indeterminateIcon,
      label: _vm.label,
      messages: _vm.messages,
      multiple: _vm.multiple,
      "off-icon": _vm.offIcon,
      "on-icon": _vm.onIcon,
      "persistent-hint": _vm.persistentHint,
      "prepend-icon": _vm.prependIcon,
      "prepend-icon-cb": _vm.prependIconCb,
      readonly: _vm.readonly,
      ripple: _vm.ripple,
      rules: _vm.rules,
      success: _vm.success,
      "success-messages": _vm.successMessages,
      "true-value": _vm.trueValue,
      "validate-on-blur": _vm.validateOnBlur,
      "value-comparator": _vm.valueComparator,
    },
    on: { change: _vm.onChange },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }